const buildUrl = (base: string, ...segments: string[]) => `/${base}/${segments.join("/")}/`;

export const ENDPOINTS = {
    Login: "login",
    BridgeAuth: "bridge-auth",
    SignUp: "signup",
    UpdatePassword: "update-password",
    /** Invite / magic-link redirect: password (+ PIN if enabled) before entering the app */
    AcceptInvite: "accept-invite",
    /** Multi-clinic users pick which clinic account to open after login */
    SelectClinic: "select-clinic",
    ResetPassword: "reset-password",
    ResendVerificationEmail: "resend-verification-email",
    EmailVerified: "email-verified",
    Calendar: "calendar",
    Appointments: "appointments",
    DocumentTypes: "document-types",
    Integrations: "integrations",
    Settings: "settings",
    /** HappyBridge install wizard — nested under settings, but its own full page, not a settings tab */
    BridgeSetup: "settings/bridge-setup",
    /** EN-1250: AVImark exam setup backup ("pick a recent exam"); its own full page under settings. */
    AvimarkExamSetup: "settings/avimark-exam-setup",
    PermissionDenied: "permission-denied",
    DocumentBuilder: "document-builder",
    Insights: "insights",
    Changelog: "changelog",
};

export const EMAIL_VERIFIED_REDIRECT_URL = `${window.location.origin}/${ENDPOINTS.EmailVerified}`;

export const APPOINTMENTS_ROUTE = buildUrl(ENDPOINTS.Appointments, ":appointment_id");

export const INDIVDUAL_DOCUMENT_TYPE_ROUTE_ADVANCED = buildUrl(ENDPOINTS.DocumentTypes, ":doc_type_id");

/** EN-1248: AVImark mapping editor for one document type (full page). ?from=builder|hub|gate picks Back; the gate also carries the visit to return to. */
export const DOCUMENT_TYPE_AVIMARK_EXPORT_ROUTE = buildUrl(ENDPOINTS.DocumentTypes, ":doc_type_id", "avimark-export");
export const avimarkExportEditorUrl = (
    documentTypeId: string,
    from: "builder" | "hub" | "gate",
    gate?: { returnTo: string },
) => {
    const q = new URLSearchParams({ from });
    if (from === "gate" && gate) q.set("returnTo", gate.returnTo);
    return `/${ENDPOINTS.DocumentTypes}/${documentTypeId}/avimark-export/?${q.toString()}`;
};
